<template>
  <div id="app">
    <div class="login_box_all loginbox">
      <div class="login_box_content">
        <div class="login_titleBox">
          <!-- <div class="login_logo hidden-sm-and-down"></div> -->
          <div class="text-center login_title login_titleBox">
           《{{ $store.state.Name }}》
          </div>
          <div class="login_maxBox" >
          <div class="container login_box"  v-show="IsSuccess">恭喜您成为本刊专家
               <p class="text-center">
                &nbsp;&nbsp;<a href="/">返回首页</a>
              </p>
          </div></div>
        </div>
        
      </div>
    </div>
   
  </div>
</template>

<script>

export default {
  name: "ExpertFromClan",
  data() {
    return {
    IsSuccess:false
    };
  },

  async mounted() {
    if (this.$route.query.Guid) {
      let data = {
        Guid: this.$route.query.Guid,
      };
      let res = await this.$store.dispatch("_AddExpertFromClanEmail", data);
      
      this.IsSuccess=res.data.IsSuccess
    } 

  },
    
  methods: {
   
  }
};
</script>

<style scoped>
.eqcode {
  font-size: 16px;
}
.loginbtn .el-button--primary {
  width: 100% !important;
}
.yzms {
  float: left;
}
</style>
